import { type Emblem } from "@common/utils/emblem";
import { getSavedEmblem, getSavedSkin, paintPlayerPreview, wornPicture } from "../emblemEditor";
import { Game } from "../game";
import { Player } from "../objects/player";
import { storeEmblemImage } from "../store/storeCatalog";

/**
 * The end screens' soldier (1.05, Last one standing and Killed in action): the player the screen is about, drawn as the
 * menu draws your kit (emblemEditor's paintPlayerPreview), in the skin and the emblem the match showed them in (a store
 * picture's read again as a picture). Your own as you wear it when the match has nothing of you left to go by; nobody
 * else's then. Whether a soldier was drawn (nothing when another end screen has been drawn since: it says its own).
 */
let drawing = 0;
export async function paintEndSoldier(canvas: HTMLCanvasElement, playerID: number, own: boolean): Promise<boolean | undefined> {
    const ticket = ++drawing;
    const object = Game.objects.get(playerID);
    const look = object instanceof Player ? object.look : undefined;
    let skin: string;
    let emblem: Emblem | undefined;
    let picture: HTMLImageElement | undefined;
    if (look) {
        skin = look.skin;
        emblem = look.emblem;
        if (look.storeEmblem) picture = await storeEmblemImage(look.storeEmblem);
    } else if (own) {
        skin = getSavedSkin();
        emblem = getSavedEmblem();
        picture = wornPicture();
    } else {
        return false;
    }
    // (another end screen since, the next match's: it draws its own)
    if (ticket !== drawing) return undefined;
    paintPlayerPreview(canvas, skin, emblem, picture);
    return true;
}
